import { render } from "./OrganogramView.vue?vue&type=template&id=61803317"
import script from "./OrganogramView.vue?vue&type=script&lang=js"
export * from "./OrganogramView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__